import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

// import { cfpBaseUrl } from "../../network/urls";
import { resetState as resetActionableNormal } from "../features/actionable/actionableNormalSlice";
import { resetState as resetActionableOverdue } from "../features/actionable/actionableOverdueSlice";
import { signOut } from "../features/authentication/authenticationSlice";
import { resetState as resetStateDueDate } from "../features/billingAndCollection/dueDateExtensionNormalSlice";
import { resetState as resetStateInstallmentsNormal } from "../features/billingAndCollection/installmentsNormalSlice";
import { resetState as resetStateInstallmentsOverdue } from "../features/billingAndCollection/installmentsOverdueSlice";
import { resetOverallPerformanceState } from "../features/dashboard/overallPerformance";
import { resetState as resetStateColNormal } from "../features/generalServices/colNormalSlice";
import { resetState as resetStateColOverdue } from "../features/generalServices/colOverdueSlice";
import { resetState as resetStateConNormal } from "../features/generalServices/coaNormalSlice";
import { resetState as resetStateConOverdue } from "../features/generalServices/coaOverdueSlice";
import { resetState as resetStateCotNormal } from "../features/generalServices/cotNormalSlice";
import { resetState as resetStateCotOverdue } from "../features/generalServices/cotOverdueSlice";
import { resetState as resetStateNcNormal } from "../features/generalServices/ncNormalSlice";
import { resetState as resetStateNcOverdue } from "../features/generalServices/ncOverdueSlice";
import { resetFeederStatusState } from "../features/geoJson/feedersStatus";
import { resetGeoJsonState } from "../features/geoJson/geoJson";
import { removeStats } from "../features/stats/statsSlice";
import { cfpBaseUrl } from "../network/urls";
import { Link, useNavigate } from 'react-router-dom';

import { resetState as resetStateAllComplaints } from "../features/powerComplaints/getComplaintSlice";

const useInactivityLogout = (navigate, timeout = 15 * 60 * 1000) => {
  const dispatch = useDispatch();
  const timer = useRef(null);
  const { token } = useSelector((state) => state.auth);

  const callLogoutAPI = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        keepalive: true,
      };

      await fetch(cfpBaseUrl + "customerFaciliationPortal/logOut", requestOptions)
        .then((response) => response.json())
        .then((result) => console.log(result))
        .catch((error) => console.error(error));
    } catch (e) { }
  };

  const logout = async () => {
    try {
      await callLogoutAPI();

      dispatch(resetStateNcNormal());
      dispatch(resetStateNcOverdue());
      dispatch(resetStateConNormal());
      dispatch(resetStateConOverdue());
      dispatch(resetStateColNormal());
      dispatch(resetStateColOverdue());
      dispatch(resetStateCotNormal());
      dispatch(resetStateCotOverdue());
      dispatch(resetStateDueDate());
      dispatch(resetStateInstallmentsNormal());
      dispatch(resetStateInstallmentsOverdue());
      dispatch(removeStats());
      dispatch(resetOverallPerformanceState());
      dispatch(resetFeederStatusState());
      dispatch(resetGeoJsonState());
      dispatch(resetActionableNormal());
      dispatch(resetActionableOverdue());
      dispatch(resetStateAllComplaints());
      dispatch(signOut());

      localStorage.clear();
      sessionStorage.clear();

      navigate("/login")
    } catch (error) {
      console.error("Auto logout failed:", error);
    }
  };

  const resetTimer = () => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(logout, timeout);
  };

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);
};

export default useInactivityLogout;

